import { ShyScrollbarCss, InfiniteScroll } from '@cycle-app/ui';
import styled from 'styled-components';

export const List = styled(InfiniteScroll)`
  ${ShyScrollbarCss}
  scroll-snap-type: y mandatory;
`;
